
import BookingSdnBanner from "@/app/ui/components/booking-sdn-banner/index.vue";
/* eslint-disable @typescript-eslint/camelcase */
import { Options, prop, Vue } from "vue-class-component";
import {
  AddressType,
  BookingMasterData,
  BookingV3,
  ConfigValidationForm,
  DocInternationalModelValueType,
  ErrorBookingV3,
  FraudStatus,
  PosterProduct,
  ShipmentIdTable
} from "@/domain/entities/CreateBookingV3";
import {
  SttAdjustment,
  SttAdjustmentRule,
  SttPiecesV2
} from "@/domain/entities/ShipmentBooking";
import SttManualReference from "../stt-manual-reference/index.vue";
import DetailSender from "../detail-sender/index.vue";
import DetailReceiver from "../detail-receiver/index.vue";
import CommoditySection from "../comodity/index.vue";
import DeliveryService from "../delivery-service/index.vue";
import DetailKoli from "../detail-koli/index.vue";
import InsuranceBanner from "../banner-product-type/index.vue";
import DeliveryType from "../delivery-type/product/index.vue";
import SectionUploadPhotoForWeightAdjusment from "@/app/ui/components/section-upload-photo-for-weight-adjustment/index.vue";
import SectionFooterBookingV3 from "../footer/index.vue";
import {
  ComodityProductPoster,
  InsuranceTypeDeliveryData,
  PayloadPosterProduct,
  PiecesPosterProduct,
  PosterProduct as PosterProductBooking,
  ShipmentId,
  ShipmentIdSTT
} from "@/domain/entities/Booking";
import {
  ApiRequestList,
  StateCondition,
  OptionsClass,
  UploadMultiple,
  ErrorMessageEntities
} from "@/domain/entities/MainApp";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { BookingController } from "@/app/ui/controllers/BookingController";
import {
  CLIENT_ERROR,
  formatByCountry,
  formatInputMoney,
  INTERNAL_SERVER_ERROR,
  INTERNET_ERROR,
  parseByCountry,
  parsingErrorResponse,
  SPECIAL_ERROR
} from "@/app/infrastructures/misc/Utils";
import { ProductController } from "@/app/ui/controllers/ProductController";
import { ProductConfigurationRuleRequestParams } from "@/data/payload/api/ProductApiRequest";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { HeavyWeightSurchargeController } from "@/app/ui/controllers/HeavyWeightSurchargeController";
import {
  maxKg,
  prefixDisableDimension,
  prefixDisableDimensionC1,
  SHIPMENT_ID_FAVOURITE,
  volumeWeightForProduct
} from "../../../booking-utils";
import { DistrictData, ZipCodeEntities } from "@/domain/entities/Location";
import {
  DeleteHydraFileRequest,
  GetEstimationPrice,
  PiecesApiRequest,
  SubmitPosterProductApiRequest,
  UploadHydraFileRequest
} from "@/data/payload/api/BookingRequest";
import { DimensionPieces } from "@/data/payload/api/CargoApiRequest";
import { ClientData } from "@/domain/entities/BulkBooking";
import { CodConfigurationController } from "@/app/ui/controllers/CodConfigurationController";
import { DetailCodConfigurationRetail } from "@/domain/entities/CodConfiguration";
import { FlagsPermissionBooking } from "@/feature-flags/flag-booking";
import { InsuranceController } from "@/app/ui/controllers/InsuranceController";
import { HeavyWeightSurchargeDetailMinimum } from "@/domain/entities/HeavyWeightSurcharge";
import { ShipmentBookingController } from "@/app/ui/controllers/ShipmentBookingController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { flags } from "@/feature-flags";
import { isEligibleForMaxVolumeWeightDiscount } from "@/app/infrastructures/misc/common-library/IsEligibleForMaxVolumeWeightDiscount";
import { FlagsFeatureShipmentC1 } from "@/feature-flags/flags-shipment-c1";
import SkeletonModalShipmentV3 from "./components/skeleton-modal-shipment-v3.vue";
import {
  AddShipmentBookingV2,
  ShipmentSttDetail,
  SttCiplRequest
} from "@/data/payload/api/ShipmentBookingRequest";
import { ERROR_SPESIFICATION } from "@/app/infrastructures/misc/common-library/ParsingErrorResponse";
import { dataLayer } from "@/app/infrastructures/misc/UtilsGtm";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import { debounce } from "lodash";
import { Pagination } from "@/domain/entities/Pagination";
import GoodsNames from "../goods-names/index.vue";
import { ResponseShipmentBooking } from "@/domain/entities/Booking";
import {
  isCustomerApps,
  isCustomerEligibleEditSize
} from "@/app/ui/views/track-delivery/delivery-tab/modules";
import { CreateBookingV3Controller } from "@/app/ui/controllers/CreateBookingV3Controller";
import { getRoundedChargeableWeightByRules } from "@/app/infrastructures/misc/common-library/v2/getRoundedChargeableWeightByRules";
import { codePhoneCountry } from "../../../../bulk-booking-v2/list-bulk-booking-utils";
import { isShipmentCa } from "@/app/ui/modules/receipt-v2/module";
import DocInternational from "../booking-extra/doc-international/index.vue";
import { RequestInternationalDocumentDetail } from "@/domain/entities/InternationalDocument";
import { InternationalDocumentController } from "@/app/ui/controllers/InternationalDocumentController";
import { CommodityCIPL } from "../../../../../../../../domain/entities/CreateBookingV3";
import { parseZodError } from "../../utils";
import {
  emailSchema,
  goodsPriceSchema,
  idNumberSchema,
  imageSchema,
  itemDetailSchema,
  quantitySchema,
  taxNumberSchema
} from "../booking-extra/doc-international/validation";
import {
  estimationPriceSchema,
  getMinMaxGoodsPriceFromFlag
} from "../detail-koli/product-price-insurance/validation";
import { CommodityController } from "@/app/ui/controllers/CommodityController";
import { resolveDefaultProductName } from "../../utils/resolveDefaultProductName";

class Props {
  modelValue = prop<boolean>({
    default: false,
    type: Boolean,
    required: true
  });
  data = prop<ShipmentIdTable[]>({
    default: () => [],
    type: Array
  });
  selectedIndex = prop<number>({
    default: 0,
    type: Number
  });
  isAddAddress = prop<boolean>({
    default: false,
    type: Boolean
  });
  isShipment = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  name: "ModalShipmentV3",
  components: {
    BookingSdnBanner,
    SttManualReference,
    DetailSender,
    DetailReceiver,
    CommoditySection,
    DeliveryService,
    DetailKoli,
    InsuranceBanner,
    DeliveryType,
    SectionUploadPhotoForWeightAdjusment,
    SectionFooterBookingV3,
    SkeletonModalShipmentV3,
    GoodsNames,
    DocInternational
  },
  watch: {
    modelValue: {
      handler(newVal) {
        if (newVal) {
          this.$emit("update:selectedIndex", 0);
          this.initShipmentForm();
          return;
        }

        this.onResetForm();
      },
      deep: true,
      immediate: true
    },
    originCountry() {
      this.getInsuranceAvailability();
    },
    isApAsRouteCodDisabled(disabled: boolean) {
      if (disabled && (this.form.isCOD || this.form.isDFOD)) {
        this.form.serviceType = "non-cod";
        this.onUpdateServiceType("non-cod");
      }
    },
  }
})
class ModalShipmentV3 extends Vue.with(Props) {
  mounted() {
    this.getInsuranceAvailability();
    ProductController.fetchVolumetricDivisors(this.accountCountryCode);
  }
  get accountCountryCode() {
    return AccountController.accountData.countryCode;
  }

  get resolveFormatCountry() {
    // For by-shipment modal: no API entity country → use auth
    // precedence: [1] API bookedForCountry (n/a), [2] auth countryCode, [3] fallback "ID"
    const authCountry = this.accountCountryCode || "ID";
    return authCountry === "MY" ? "MY" : "ID";
  }
  get visible() {
    return this.modelValue;
  }
  set visible(val: boolean) {
    if (!val) {
      this.stateCondition.confirmClose = true;
      return;
    }

    this.$emit("update:modelValue", val);
  }
  onCloseForm() {
    this.$emit("update:modelValue", false);
    this.stateCondition.confirmClose = false;
  }

  dataRuleShipmentBooking = new ResponseShipmentBooking();
  async getFieldShipmentBookingRule() {
    this.dataRuleShipmentBooking = await BookingController.getFieldShipmentBooking(
      this.data[this.selectedIndex].shipmentId
    );
  }

  currentIndex = 0;
  form = new BookingV3();
  stateCondition = new StateCondition();
  errors = new ErrorBookingV3();
  masterData = new BookingMasterData();
  configRule = new SttAdjustment();

  get shipmentDetail(): ShipmentIdTable {
    // ⚠️ This getter returns the original shipment data based on the selected index.
    // ✅ DO NOT mutate or directly consume this data in components or business logic.
    // ✅ If you need to use or update this data, always work with `this.form` instead,
    // ✅ since all user-driven or programmatic mutations are tracked in `form`.
    return this.data[this.selectedIndex];
  }
  get referenceExternal(): string {
    const { dataRaw, shipmentBookingId, STT } = this.shipmentDetail;

    if (this.isCourierRecommendation) return dataRaw.ticket_code;
    if (shipmentBookingId.startsWith("TSLP")) return shipmentBookingId;
    if (STT?.sttNoRefExternal) return STT?.sttNoRefExternal;
    return "";
  }

  get renderPieces(): SttPiecesV2[] {
    const { shipmentGoodDetail } = this.shipmentDetail;

    const normalizeDimension = (value = 10): number => value;

    if (!shipmentGoodDetail.length) {
      const length = normalizeDimension(3);
      const width = normalizeDimension(20);
      const height = normalizeDimension(10);

      const volumeWeight = (length * width * height) / this.division;

      return [
        new SttPiecesV2({
          grossWeight: "0",
          dimension: new DimensionPieces({
            length,
            width,
            height
          }),
          volumeWeight,
          convertVolumeWeight: this.formatWeight(volumeWeight),
          isDimensionDisabled: this.disabled.dimension
        })
      ];
    }

    return shipmentGoodDetail.map((item) => {
      const length = normalizeDimension(item.shipment_goods_length);
      const width = normalizeDimension(item.shipment_goods_width);
      const height = normalizeDimension(item.shipment_goods_height);

      const volumeWeight = (length * width * height) / this.division;

      return new SttPiecesV2({
        grossWeight: String(item.shipment_goods_weight),
        dimension: new DimensionPieces({ length, width, height }),
        volumeWeight,
        convertVolumeWeight: this.formatWeight(volumeWeight),
        warningHwsSingle:
          this.minimumHeavyWeightSurcharge.minimumExist &&
          shipmentGoodDetail.length === 1 &&
          item.shipment_goods_weight >=
            this.minimumHeavyWeightSurcharge.heavyWeightMinimum,
        errorHws:
          this.minimumHeavyWeightSurcharge.minimumExist &&
          shipmentGoodDetail.length > 1 &&
          item.shipment_goods_weight >=
            this.minimumHeavyWeightSurcharge.heavyWeightMinimum,
        isDimensionDisabled: this.disabled.dimension
      });
    });
  }

  get isShipmentFavorite(): boolean {
    return this.validationPrefix(["AP", "AS"]);
  }
  get isShipmentMp(): boolean {
    const flags = FlagsPermissionBooking.permission_shipment_booking_mp.getValue();
    return Boolean(flags && new RegExp(flags).test(this.form.shipmentId));
  }
  get configDisableC1() {
    return (
      !prefixDisableDimensionC1(
        String(AccountController.accountData.account_id)
      ) && this.validationPrefix(["C1", "C2"])
    );
  }

  get accountIsNonForeign() {
    return AccountController.accountData.countryCode === "id";
  }

  async getCommodityDetail(code = "") {
    return CommodityController.getDetailCommodityByCode(code);
  }

  async setForm() {
    const d = this.shipmentDetail;

    const normalizedPostalCode = new DistrictData({
      name:
        d.postalCodeDestination && typeof d.postalCodeDestination === "object"
          ? d.postalCodeDestination.id
          : d.postalCodeDestination
    });

    const insuranceType = /basic/i.test(d.shipmentInsurance) ? "basic" : "free";

    const commodityDetail = await this.getCommodityDetail(
      d.shipmentCommodityCode as string
    );

    let commodity = new OptionsClass({
      id: d.shipmentCommodityId,
      name: d.shipmentCommodityName as string,
      value: d.shipmentCommodityCode as string,
      code: d.shipmentCommodityCode as string
    });

    if (commodityDetail.commodity_id) {
      commodity = new OptionsClass({
        id: commodityDetail.commodity_id,
        name: this.accountIsNonForeign
          ? (commodityDetail.commodity_name as string)
          : (commodityDetail.commodity_name_en as string),
        value: commodityDetail.commodity_code as string,
        code: commodityDetail.commodity_code as string
      });
    }

    const addressType = d.sttRecipientAddressType || AddressType.rumah;
    const addressReceiverType = new OptionsClass({
      name: addressType,
      value: addressType
    });

    const adjustmentWeightAttachments = new Array(
      flags.flag_max_photo_for_weight_adjustment.getValue()
    ).fill("");

    this.form = new BookingV3({
      clientName: new ClientData({ clientId: d.shipmentSttClientId }),
      shipmentId: d.shipmentAlgoId,
      referenceExternal: this.referenceExternal,
      sender: d.shipmentSenderName,
      phoneCodeSender: d.shipmentSenderPhoneCode,
      phoneSender: d.shipmentSenderPhone,
      addressSender: d.shipmentSenderAddress,
      receiver: d.shipmentRecipientName,
      phoneCodeReceiver: d.shipmentRecipientPhoneCode,
      phoneReceiver: d.shipmentRecipientPhone,
      addressReceiver: d.shipmentRecipientAddress,
      postalCodeDestination: normalizedPostalCode,
      addressReceiverType,
      commodity,
      productName: d.shipmentProduct,
      estimationPrice: formatInputMoney(d.shipmentGoodsPriceEstimation || ""),
      codAmount: formatInputMoney(d.codAmount),
      insurance: insuranceType,
      isCOD: d.shipmentIsCod,
      isDFOD: d.shipmentIsDfod,
      sttNextCommodity: d.nextCommodity,
      woodpacking: d.shipmentIsWoodpacking,
      adjustmentWeightAttachments,
      sttIsCod: d.shipmentIsCod,
      sttIsDfod: d.shipmentIsDfod,
      docInternationalForm: new DocInternationalModelValueType({
        ...d.STT?.sttCipl,
        listCommodityCIPL: d.STT?.sttCipl?.listCommodityCIPL?.map(
          (e) => new CommodityCIPL(e)
        ),
        dutyTaxTerms: "DAP"
      })
    });

    this.form.phoneFlagSender = codePhoneCountry(
      d.shipmentSenderPhoneCode + d.shipmentSenderPhone
    ).flag;
    this.form.phoneFlagReceiver = codePhoneCountry(
      d.shipmentRecipientPhoneCode + d.shipmentRecipientPhone
    ).flag;
    this.form.pieces = this.renderPieces;

    this.setConfigRule();
  }

  validationPrefix(prefix: string[]): boolean {
    return prefix.some((e) =>
      (this.shipmentDetail?.shipmentAlgoId || "").startsWith(e)
    );
  }

  get originDistrictDetail() {
    return LocationController.districtDetail;
  }
  get destinationCity(): DistrictData {
    const { destinationCity } = this.form;
    return destinationCity instanceof DistrictData
      ? new DistrictData(destinationCity)
      : new DistrictData();
  }
  get postalCodeDestination() {
    const { postalCodeDestination } = this.form;
    return postalCodeDestination instanceof DistrictData
      ? postalCodeDestination
      : new DistrictData();
  }
  get commodity() {
    const { commodity } = this.form;

    return typeof commodity === "object"
      ? new ComodityProductPoster({
          commodityId: commodity.id,
          commodityName: commodity.name,
          commodityCode: commodity.code
        })
      : new ComodityProductPoster();
  }

  get displayGoodsName(): boolean {
    return this.validationPrefix(["T1", "B1", "B2", "TKP"]);
  }
  get goodsName(): string {
    return this.shipmentDetail.shipmentGoodDetail
      .map((item) => item["shipment_goods_name"])
      .join(", ");
  }

  get checkFraudSenderPhone(): boolean {
    return this.validationPrefix(["ARA", "ARB", "AP", "AS"]);
  }

  get isCourierRecommendation(): boolean {
    return !!this.shipmentDetail?.dataRaw?.ticket_code;
  }
  get isVendorNinja(): boolean {
    return ShipmentBookingController.isVendorNinja;
  }
  get isProductSameday(): boolean {
    return (
      BookingController.isSameDayProduct &&
      /sameday/i.test(this.form.productName)
    );
  }

  get isCustomerAppsPrefix(): boolean {
    return isCustomerApps(this.form.shipmentId);
  }

  get isCustomerPrefixEligibleEditSize(): boolean {
    return isCustomerEligibleEditSize(this.form.shipmentId);
  }

  isDisabled(value: string | number | boolean) {
    return new SttAdjustmentRule({
      rule: value
        ? ConfigValidationForm.NON_EDITABLE
        : ConfigValidationForm.EDITABLE
    });
  }
  setConfigRule() {
    const { isDO } = this.shipmentDetail;
    const {
      shipmentId,
      sender,
      phoneSender,
      addressSender,
      receiver,
      phoneReceiver,
      addressReceiver,
      isCOD,
      productName,
      estimationPrice,
      codAmount
    } = this.form;

    const showTariff =
      this.validationPrefix(["AP", "AS", "ARA", "ARB"]) ||
      this.isCustomerAppsPrefix ||
      (this.validationPrefix(["C1", "C2"]) && isCOD);

    this.configRule = new SttAdjustment({
      shipmentId: this.isDisabled(shipmentId),
      manualSttNo: this.isDisabled(!this.isShipmentFavorite),
      sttNoRefExternal: this.isDisabled(
        this.isShipmentFavorite ? false : !isDO
      ),
      senderName: this.isDisabled(sender),
      senderPhone: this.isDisabled(phoneSender),
      senderAddress: this.isDisabled(addressSender),
      recipientName: this.isDisabled(receiver),
      recipientPhone: this.isDisabled(phoneReceiver),
      recipientAddress: this.isDisabled(addressReceiver),
      recipientDistrict: this.isDisabled(this.destinationCity.name),
      recipientPostalCode: this.isDisabled(this.postalCodeDestination.name),
      commodity: this.isDisabled(false),
      goodsPrice: this.isDisabled(
        !this.isShipmentFavorite &&
          this.validateEstimationPrice(estimationPrice)
      ),
      codAmount: this.isDisabled(!this.isShipmentFavorite || codAmount),
      insurance: this.isDisabled(this.disabled.insurance),
      grossWeight: this.isDisabled(this.disabled.grossWeight),
      dimension: this.isDisabled(this.disabled.dimension),
      adjustPiece: this.isDisabled(this.disabled.addPiece),
      productType: this.isDisabled(productName),
      tariff: new SttAdjustmentRule({
        rule: showTariff
          ? ConfigValidationForm.SHOW
          : ConfigValidationForm.NON_SHOW
      }),
      interCipl: new SttAdjustmentRule({
        rule: ConfigValidationForm.NON_EDITABLE
      })
    });

    if (this.isShipmentFavorite) {
      this.configRule.interCipl = new SttAdjustmentRule({
        rule: ConfigValidationForm.EDITABLE
      });
    }
  }

  onResetForm() {
    this.currentIndex = 0;
    this.form = new BookingV3();
    this.stateCondition = new StateCondition();
    this.errors = new ErrorBookingV3();
    this.masterData = new BookingMasterData();
    this.configRule = new SttAdjustment();
  }
  onCloseSuccessProcess() {
    if (this.data.length && this.selectedIndex < this.data.length - 1) {
      this.onSkipBooking();
      return;
    }

    this.onCloseForm();
  }

  async initShipmentForm() {
    this.stateCondition = new StateCondition({
      loadingForm: true,
      openAdjustmentWeight: false
    });

    this.setForm();
    await AccountController.checkAccountLocation();
    await this.getDetailDistrict();
    await this.getCodConfig();
    await this.getHwsConfig();
    await this.getProductConfig();
    await this.getFieldShipmentBookingRule();

    // wait for valid form
    await this.getInsuranceConfig();
    await this.getUpselling();

    if (!this.disabled.submit) {
      await this.getEstimationPrice();
    }

    if (this.isApAsRouteCodDisabled && (this.form.isCOD || this.form.isDFOD)) {
      this.form.serviceType = "non-cod";
      this.onUpdateServiceType("non-cod");
    }

    this.stateCondition.loadingForm = false;
  }

  async getDetailDistrict() {
    const { shipmentDestinationDistrict } = this.shipmentDetail;

    LocationController.setZipCodeData(
      new ZipCodeEntities(new Pagination(1, 20), [])
    );

    if (!shipmentDestinationDistrict?.code) {
      LocationController.setEmptyDestinationDistrict();
      return;
    }

    await LocationController.getDetailDistrictByDistrictCode({
      districtCode: shipmentDestinationDistrict.code
    });

    const districtDetail = LocationController.destinationDistrict;

    this.form.destinationCity = new DistrictData(districtDetail);

    const zipCodeList = districtDetail.destinationListZipCode
      .filter((item) => item)
      .map(
        (item: any) =>
          new DistrictData({
            id: item,
            name: item
          })
      );
    LocationController.setZipCodeData(
      new ZipCodeEntities(new Pagination(1, 20), zipCodeList)
    );

    this.setConfigRule();
    return;
  }

  get countryCode() {
    return ProductController.countryCode;
  }
  get volumetricDivisorMap() {
    return ProductController.volumetricDivisorMap;
  }

  get division() {
    return volumeWeightForProduct(
      this.form.productName,
      this.volumetricDivisorMap,
      this.countryCode
    );
  }
  get minimumHeavyWeightSurcharge() {
    return HeavyWeightSurchargeController.heavyWeightMinimum;
  }

  get isClient() {
    const { isPosAccount, isInternalAccount } = AccountController.accountData;
    return (
      this.form.clientName.clientName && (isPosAccount || isInternalAccount)
    );
  }

  getUpsellingAndTarif = debounce(async (_this = this) => {
    await _this.getUpselling();
    await _this.getEstimationPrice();
  }, 500).bind(this);

  async getUpselling() {
    if (!this.destinationCity.id) return;
    if (!this.isShipmentFavorite) {
      this.form.productName =
        this.form.productName || this.shipmentDetail.shipmentProduct;
      this.masterData.upsellingList = [
        new PosterProduct({
          productType: this.form.productName
        })
      ];
      return;
    }

    try {
      this.stateCondition.loadingUpselling = true;

      const f = this.form;

      const res: PosterProductBooking[] = await BookingController.postToGetPosterProduct(
        new SubmitPosterProductApiRequest({
          payload: new PayloadPosterProduct({
            originId: this.originDistrictDetail.code,
            destinationId: this.destinationCity.code,
            commodity: { data: this.commodity },
            commodityId: this.commodity.commodityId || 499,
            isCod: f.isCOD || f.isDFOD,
            isDfod: f.isDFOD,
            codAmount: this.parseNumber(f.codAmount),
            goodsPrice: this.parseNumber(f.estimationPrice),
            pieces: this.form.pieces?.map((piece: SttPiecesV2) => {
              const {
                width,
                length,
                height
              } = piece.dimension as DimensionPieces;

              return new PiecesPosterProduct({
                pieceWidth: Number(width),
                pieceLength: Number(length),
                pieceHeight: Number(height),
                pieceGrossWeight: !piece.grossWeight
                  ? 1
                  : this.parseNumber(piece.grossWeight)
              });
            }),
            accountType: "client",
            accountRefId: 2311,
            isBookingPuposes: false,
            insuranceType: f.insurance,
            isWoodpacking: f.woodpacking,
            shipmentPrefix: f.shipmentId?.slice(0, 2)
          })
        })
      );

      this.masterData.upsellingList = res.map(
        (product: PosterProductBooking) =>
          new PosterProduct({
            productType: product.name,
            estimateSla: product.sla,
            totalTariffAfterDiscount: product.total_tariff_after_discount,
            commissionRate: product.commission_rate,
            bookingCommission: product.booking_commission,
            isEmbargo: product.is_embargo,
            shippingCost: product.shipping_cost
          })
      );
      // this.form.productName =
      //   f.productName || this.shipmentDetail.shipmentProduct;
      if (!this.masterData.upsellingList.length) return;
      this.form.productName = resolveDefaultProductName(this.productList, this.masterData.upsellingList, this.form.productName);
    } catch (err) {
      this.onErrorGetUpselling(err);
    } finally {
      this.stateCondition.loadingUpselling = false;
    }
  }
  onErrorGetUpselling(err: any) {
    const type = parsingErrorResponse(err).type;
    if (type !== INTERNAL_SERVER_ERROR) return;

    this.errors.upselling = type;
    this.masterData.upsellingList = [];
    this.form.productName = "";
  }
  get isErrorEmbargoDestination(): boolean {
    return [
      this.masterData.upsellingList.length,
      this.masterData.upsellingList.every((item) => item.isEmbargo),
      this.form.destinationCity
    ].every(Boolean);
  }
  get productList() {
    const productData = this.masterData.productList;
    if (
      this.shipmentDetail.shipmentProduct &&
      !productData.includes(this.shipmentDetail.shipmentProduct)
    ) {
      productData.push(this.shipmentDetail.shipmentProduct);
    }
    return productData.filter(
      (product) => !["ONEPACK", "VIPPACK"].includes(product.toUpperCase())
    );
  }

  async getCodConfig() {
    const res = await CodConfigurationController.getList(
      new ApiRequestList({
        page: 1,
        limit: 20
      })
    );

    const ccoNameByPrefix = this.validationPrefix(["T"])
      ? "COD TOKOPEDIA MP"
      : this.isCustomerAppsPrefix
      ? "COD CA RETAIL"
      : "";

    this.masterData.codActiveConfig = new DetailCodConfigurationRetail(
      res.data.find(
        (config: DetailCodConfigurationRetail) =>
          config.ccoName === ccoNameByPrefix
      )
    );

    const ccoDFODNameByPrefix = this.isCustomerAppsPrefix ? "DFOD CA" : "";

    this.masterData.dfodActiveConfig = new DetailCodConfigurationRetail(
      res.data.find(
        (config: DetailCodConfigurationRetail) =>
          config.ccoName === ccoDFODNameByPrefix
      )
    );
    this.setConfigRule();
  }

  async getHwsConfig() {
    this.masterData.hwsConfig = await HeavyWeightSurchargeController.getDetailHeavyWeightSurcharge(
      { id: 1 }
    );
  }
  get hwsMinimumData() {
    const { productName } = this.form;

    const hws = this.masterData.hwsConfig.configurableHeavyWeight;
    if (!hws) return new HeavyWeightSurchargeDetailMinimum();

    const isActive =
      this.masterData.hwsConfig.configurablePriceStatus.toLowerCase() ===
      "active";
    const isEnabled = FlagsPermissionBooking.hws_configuration.isEnabled();

    const productIncluded = hws.heavy_weight_surcharge_product_include.product_types.includes(
      productName.toUpperCase()
    );

    const isExcludedCommodity = hws.heavy_weight_surcharge_commodity_exclude.commodities.some(
      ({ commodity_code, commodity_name }: any) =>
        commodity_code === this.commodity.commodityCode ||
        commodity_name === this.commodity.commodityName
    );

    const shouldSetMinimum =
      isActive && isEnabled && productIncluded && !isExcludedCommodity;

    return shouldSetMinimum
      ? new HeavyWeightSurchargeDetailMinimum({
          heavyWeightMinimum:
            hws.heavy_weight_surcharge_additional_cost.additional_costs[0]
              ?.weight_min,
          minimumExist: true
        })
      : new HeavyWeightSurchargeDetailMinimum();
  }

  async getProductConfig() {
    this.masterData.productConfig = await ProductController.fetchProductConfigurationRule(
      new ProductConfigurationRuleRequestParams({
        page: 1,
        isNoLimit: true,
        countryCode: this.accountCountryCode
      })
    );
  }

  async getInsuranceConfig() {
    const { estimationPrice, insurance } = this.form;

    if (!estimationPrice) return;

    this.masterData.insuranceConfig = await InsuranceController.getInsurance(
      new ApiRequestList({
        isPagination: true,
        typeInsurance: insurance,
        goodsPrice: this.parseNumber(estimationPrice),
        country: AccountController.accountData.countryCode,
        accountType: "client",
        accountRefId: 2311
      })
    );
  }

  getInsuranceAvailability = debounce(async () => {
    if (this.accountCountryCode !== "MY") return;

    await BookingController.getInsuranceTypesDelivery({
      insuranceConfig: 2,
      originCountry: this.originCountry
    });
  }, 500);

  get insuranceBasic() {
    const basic = BookingController.insuranceTypeDelivery.data.find(
      (item: InsuranceTypeDeliveryData) => item.value === "basic"
    );

    return new InsuranceTypeDeliveryData(basic);
  }

  get originCountry() {
    return (
      this.districtDetail?.countryCode ??
      AccountController.accountData.countryCode
    );
  }

  get districtDetail() {
    return LocationController.districtDetail;
  }

  get isExistingInsuranceApplied() {
    return (
      this.form.insurance !== "free"
    );
  }

  async onUploadAdjustmentWeight(params: UploadMultiple) {
    if (!params.file) return;

    MainAppController.closeMessageModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      const fileLink = await BookingController.uploadHydraFile(
        new UploadHydraFileRequest({
          attachFile: params.file,
          folderPath: "stt/"
        })
      );
      this.form.adjustmentWeightAttachments[params.index] = fileLink.data;
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, this.$t("bookingShipment.error.uploadPhoto"))
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  async onRemoveAdjustmentWeight(index: number) {
    MainAppController.closeMessageModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      const res = await BookingController.deleteHydraFile(
        new DeleteHydraFileRequest({
          attachFiles: [this.form.adjustmentWeightAttachments[index]]
        })
      );
      const statusDel = res.data[this.form.adjustmentWeightAttachments[index]];

      if (statusDel) {
        this.form.adjustmentWeightAttachments[index] = "";
      }
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          err,
          this.$t("bookingV3.shipment.modal.deletePhotoFailed")
        )
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  errorEstimation = "";

  get isShipmentCA(): boolean {
    return isShipmentCa(this.form.shipmentId);
  }

  async getEstimationPrice() {
    const {
      productName,
      insurance,
      woodpacking,
      pieces,
      isCOD,
      isDFOD,
      codAmount,
      estimationPrice,
      shipmentId
    } = this.form;

    if (!this.destinationCity.id || !productName) return;

    if (!this.isCustomerAppsPrefix && this.disabledPiece.adjustmentWeight) {
      this.masterData.tarifEstimation.chargeableWeight = this.shipmentDetail.shipmentChargeableWeight;
      return;
    }

    try {
      this.stateCondition.loadingEstimationPrice = true;
      this.errors.estimationPrice = false;
      this.errorEstimation = "";
      this.masterData.tarifEstimation = await BookingController.getEstimationPriceForNewBooking(
        new GetEstimationPrice({
          originId: this.originDistrictDetail.code,
          destinationId: this.destinationCity.code,
          commodityId: this.commodity.commodityId,
          productType: productName,
          accountType: "client",
          accountRefId: 2311,
          insuranceType: insurance,
          isWoodpacking: woodpacking,
          isHaveTaxId: false,
          pieces: pieces.map((piece: SttPiecesV2) => {
            const {
              width,
              length,
              height
            } = piece.dimension as DimensionPieces;

            return new PiecesPosterProduct({
              pieceLength: length,
              pieceWidth: width,
              pieceHeight: height,
              pieceGrossWeight: this.parseNumber(piece.grossWeight)
            });
          }) as [],
          isCod: isCOD,
          isDfod: isDFOD,
          codHandling: "",
          codAmount: this.parseNumber(codAmount || estimationPrice),
          goodsPrice: this.parseNumber(estimationPrice),
          isDisablePromo: false,
          promoAppliedTo: "shipment",
          isPad: false,
          shipmentPrefix: this.estimationShipmentPrefix(shipmentId),
          hideError: false,
          discountFavoritePercentage: 0,
          shipmentCreatedAt: this.isShipmentCA
            ? this.shipmentDetail.shipmentCreatedAt
            : "",
          sttBookedAt: this.isShipmentCA ? new Date().toISOString() : ""
        })
      );
    } catch (err) {
      this.errors.estimationPrice = parsingErrorResponse(err).type;
      const message = err.response
        ? (err.response.data.message.id as string)
        : "";
      if (
        err.response?.status === 422 &&
        (message.includes("COD") || message.includes("DFOD"))
      ) {
        this.errorEstimation = message;
      }
    } finally {
      this.stateCondition.loadingEstimationPrice = false;
    }
  }

  onUpdateServiceType(type: "non-cod" | "cod" | "dfod") {
    this.form.isCOD = type === "cod" || type === "dfod";
    this.form.isDFOD = type === "dfod";

    this.getUpsellingAndTarif(this);
  }

  get adjustmentWeightNotAllowed(): boolean {
    const prefixAllowed = ["AP", "AS"];
    const { shipmentId, referenceExternal } = this.form;
    const prefixShipment = this.isCourierRecommendation
      ? referenceExternal
      : shipmentId;
    const prefixAllowedValidate = prefixAllowed.some((item) =>
      prefixShipment.startsWith(item)
    );
    return prefixAllowedValidate;
  }

  get phoneFraudData() {
    const { status, isBlacklist } = BookingController.phoneCheckerData;

    return {
      limited:
        status === FraudStatus.LIMITED &&
        FlagsPermissionBooking.disable_cod_dfod_for_limited_number.isEnabled(),
      blacklist: isBlacklist
    };
  }

  get bookingSummary() {
    const { productName } = this.form;

    // Step 1: Calculate weights
    const totalGrossWeight = parseFloat(
      this.form.pieces
        .reduce((sum, item: any) => sum + this.parseNumber(item.grossWeight), 0)
        .toFixed(2)
    );

    const totalVolumeWeight = parseFloat(
      this.form.pieces
        .reduce(
          (sum, item: any) => sum + this.parseNumber(item.convertVolumeWeight),
          0
        )
        .toFixed(2)
    );

    const maxWeight = Math.max(totalGrossWeight, totalVolumeWeight);

    // Step 2: Retrieve rule and eligibility
    const productRule = this.masterData.productConfig.data.find(
      (rule) => rule.product.toLowerCase() === productName?.toLowerCase()
    );
    const roundingThreshold = productRule?.parameter ?? 0.31;

    const isEligibleForDiscount = isEligibleForMaxVolumeWeightDiscount({
      productType: productName,
      volumeWeight: totalVolumeWeight
    });

    // Step 3: Determine which weight to round
    let baseWeightToRound = maxWeight;

    if (productName) {
      baseWeightToRound = isEligibleForDiscount ? totalGrossWeight : maxWeight;
    }

    const totalChargeableWeight = getRoundedChargeableWeightByRules({
      chargeableWeight: baseWeightToRound,
      productType: productName.toUpperCase(),
      rule: roundingThreshold,
      ruleKey: productRule?.ruleKey
    });

    return {
      totalGrossWeight,
      totalVolumeWeight,
      totalChargeableWeight
    };
  }

  get disabled() {
    const e = this.errors;

    // get updated for save sender or receiver
    this.configRule = new SttAdjustment({
      ...this.configRule,
      senderSave: this.isDisabled(
        this.isShipmentFavorite
          ? false
          : [e.sender, e.phoneCodeSender, e.phoneSender, e.addressSender].some(
              (hasError) => hasError
            )
      ),
      recipientSave: this.isDisabled(
        this.isShipmentFavorite
          ? false
          : [
              e.receiver,
              e.phoneCodeReceiver,
              e.phoneReceiver,
              e.addressReceiver,
              !this.destinationCity.code,
              !this.postalCodeDestination.name
            ].some((hasError) => hasError)
      )
    });

    const insuranceDisabled = [
      !this.isShipmentFavorite && !this.isCourierRecommendation,
      this.isShipmentMp,
      this.validationPrefix(["C1", "C2"]),
      this.isProductSameday
    ].some(Boolean);

    return {
      ...this.disabledPiece,
      insurance: insuranceDisabled,
      serviceType: !this.isShipmentFavorite,
      submit: !this.validForm
    };
  }

  get disabledPiece() {
    const { STT } = this.shipmentDetail;
    const { pieces, adjustmentWeightAttachments, shipmentId } = this.form;

    const adjustmentWeight =
      this.validationPrefix([
        "T1",
        "TKLP",
        "TKP",
        "C1",
        "C2",
        "AD",
        "ACA",
        "ACB",
        "AO",
        "AI",
        "ARA",
        "ARB",
        "AG",
        "B1",
        "B2"
      ]) && adjustmentWeightAttachments.filter(Boolean).length < 2;

    // disabled for piece list gross weight and volume weight
    const isPrefixDisableDimension = prefixDisableDimension(shipmentId);
    const disabledPieceDetail =
      isPrefixDisableDimension &&
      [
        STT?.sttId,
        this.isShipmentMp,
        this.configDisableC1,
        adjustmentWeight,
        this.isProductSameday
      ].some(Boolean);

    if (!disabledPieceDetail) {
      this.configRule.grossWeight = this.isDisabled(false);
      this.configRule.dimension = this.isDisabled(false);
    }

    // disabled for add pieces
    let disabledAddPiece = false;
    if (!this.isProductSameday) {
      const sumWeight = (key: string) =>
        pieces.reduce((total, p) => total + Number(p[key]), 0);

      const overMaxWeight = ["grossWeight", "volumeWeight"].some(
        (type) => sumWeight(type) > maxKg
      );
      const greatherMaxPiece = pieces.length > 15;

      disabledAddPiece = [
        this.isVendorNinja,
        overMaxWeight,
        !this.isShipmentMp,
        !this.configDisableC1,
        greatherMaxPiece
      ].some(Boolean);
    }

    return {
      grossWeight: disabledPieceDetail,
      dimension: disabledPieceDetail || isPrefixDisableDimension,
      addPiece: disabledAddPiece,
      adjustmentWeight
    };
  }

  get validForm(): boolean {
    const { isDO, shipmentGoodsStatus } = this.shipmentDetail;
    const f = this.form;
    const e = this.errors;
    const { blacklist, limited } = this.phoneFraudData;

    const fraudCheck =
      !this.validationPrefix(["ARA", "ARB"]) ||
      [blacklist, limited].every((v) => !v);

    const normalizePrice = this.parseNumber(f.estimationPrice);

    return [
      // Destination
      this.destinationCity.cityCode,
      this.destinationCity.code,

      // Sender & Receiver
      !e.sender,
      !e.phoneCodeSender,
      !e.phoneSender,
      !e.addressSender,
      !e.receiver,
      !e.phoneCodeReceiver,
      !e.phoneReceiver,
      !e.addressReceiver,
      fraudCheck,

      // Product & Insurance
      f.productName,
      this.commodity.commodityCode,
      f.insurance,
      normalizePrice > 0,

      // Weights & Limits
      this.validPieces,
      !CreateBookingV3Controller.errorChWeightMaxGapShipmentMp,

      // Special rules
      !isDO || f.referenceExternal,
      !this.isCourierRecommendation || shipmentGoodsStatus,

      // Services
      this.validCod,
      this.validDfod,
      this.isDocInternationalFormValid,
      this.isEstimationPriceValid
    ].every(Boolean);
  }

  get validPieces() {
    const { pieces } = this.form;

    const filledPieces = pieces.every((p: SttPiecesV2) => {
      const { width, length, height } = p.dimension;

      return [
        this.parseNumber(p.grossWeight),
        [width, length, height].every(Boolean),
        p.volumeWeight,
        !p.errorHws,
        !p.warningHwsSingle,
        !this.isShipmentCA || !p.errorGrossWeight,
        !this.isShipmentCA || !p.errorVolumeWeight
      ].every(Boolean);
    });

    return [
      pieces.length,
      filledPieces,
      !this.isVendorNinja || pieces.length === 1,
      this.bookingSummary.totalVolumeWeight <= maxKg
    ].every((valid) => valid);
  }
  get validCod() {
    const { codActiveConfig } = this.masterData;
    const { estimationPrice, sttIsCod, insurance } = this.form;
    if (!sttIsCod) return true;

    const normalizePrice = this.parseNumber(estimationPrice);
    return [
      !codActiveConfig.ccoMinPrice ||
        normalizePrice >= codActiveConfig.ccoMinPrice,
      !codActiveConfig.ccoMaxPrice ||
        normalizePrice <= codActiveConfig.ccoMaxPrice,
      !codActiveConfig.ccoIsInsurance || insurance === "free"
    ].every(Boolean);
  }

  get validDfod() {
    const { dfodActiveConfig } = this.masterData;
    const { productName, insurance, estimationPrice, sttIsDfod } = this.form;
    if (!sttIsDfod) return true;

    const normalizePrice = this.parseNumber(estimationPrice);
    const productIncluded =
      dfodActiveConfig.ccoStatus !== "active" ||
      dfodActiveConfig.ccoProductType
        .toUpperCase()
        .includes(productName.toUpperCase());

    return [
      !dfodActiveConfig.ccoMinPrice ||
        normalizePrice >= dfodActiveConfig.ccoMinPrice,
      !dfodActiveConfig.ccoMaxPrice ||
        normalizePrice <= dfodActiveConfig.ccoMaxPrice,
      !dfodActiveConfig.ccoIsInsurance || insurance === "free",
      this.destinationCity.isCod === "yes",
      productIncluded
    ].every(Boolean);
  }

  get isShowSectionCipl(): boolean {
    if (!this.destinationCity.id || !this.form.productName) return false;

    const name = this.form.productName.trim().toUpperCase();
    return (
      FlagsMedusa.flag_release_interpack_additional_info.isEnabled() &&
      (name === "INTERPACK" || name === "INTERPACKMAXI")
    );
  }

  get deliveryFeeType() {
    if (this.form.isCOD && this.form.isDFOD) return "dfod";
    if (this.form.isCOD) return "cod";
    return "non-cod";
  }

  get minMaxType() {
    const type = this.isShipmentCA
      ? "shipment_ca"
      : this.validationPrefix([
          "T1",
          "TKLP",
          "TKP",
          "TSLP",
          "C1",
          "C2",
          "B1",
          "B2"
        ])
      ? "shipment_corporate"
      : "retail";
    return type;
  }

  get minMaxConfig() {
    return getMinMaxGoodsPriceFromFlag(this.minMaxType);
  }

  get isEstimationPriceValid() {
    const price = this.parseNumber(this.form.estimationPrice);
    const validation = {
      isEstimationPriceValid: !parseZodError(estimationPriceSchema, {
        estimationPrice: String(price),
        minEstimationPrice: this.minMaxConfig.min,
        maxEstimationPrice: this.minMaxConfig.max,
        productName: this.form.productName,
        listCodActive: this.masterData.codActiveConfig,
        listDfodActive: this.masterData.dfodActiveConfig,
        deliveryFeeType: this.deliveryFeeType,
        isFormBookClient: false
      })
    };
    if (this.excludeEstimationValidation) {
      return true;
    } else {
      return !Object.values(validation).includes(false);
    }
  }

  get isDocInternationalFormValid() {
    if (!this.isShowSectionCipl) return true;

    const validation = {
      isEmailValid: !parseZodError(
        emailSchema(
          this.internationalDocumentDetailData.email,
          false,
          this.form.docInternationalForm.email
        ),
        this.form.docInternationalForm.email
      ),
      isIdentityNumberValid: !parseZodError(
        idNumberSchema(
          this.internationalDocumentDetailData.idcIsIdentityNumber
        ),
        this.form.docInternationalForm.idNumber || ""
      ),
      isTaxNumberValid: !parseZodError(
        taxNumberSchema(
          this.internationalDocumentDetailData.idcIsTaxIdentificationNumber,
          false,
          this.form.docInternationalForm.taxNumber || "",
          100,
          1
        ),
        this.form.docInternationalForm.taxNumber || ""
      ),
      isIdentityImageValid: !parseZodError(
        imageSchema(
          this.internationalDocumentDetailData.ktp,
          this.form.docInternationalForm.imageIdUrl
        ),
        this.form.docInternationalForm.imageIdUrl
      ),
      isTaxImageValid: !parseZodError(
        imageSchema(
          this.internationalDocumentDetailData.npwp,
          this.form.docInternationalForm.imageTaxUrl
        ),
        this.form.docInternationalForm.imageTaxUrl
      ),
      isBeforePackingImageValid: !parseZodError(
        imageSchema(
          this.internationalDocumentDetailData.afterPacking,
          this.form.docInternationalForm.imageBeforePackingUrl
        ),
        this.form.docInternationalForm.imageBeforePackingUrl
      ),
      isAfterPackingImageValid: !parseZodError(
        imageSchema(
          this.internationalDocumentDetailData.afterPacking,
          this.form.docInternationalForm.imageAfterPackingUrl
        ),
        this.form.docInternationalForm.imageAfterPackingUrl
      ),
      isCIPLValid: this.validateCIPL()
    };

    return !Object.values(validation).includes(false);
  }
  validateCIPL(isFtz = false) {
    if (!this.internationalDocumentDetailData.commodity && !isFtz) return true;
    const validations: boolean[] = [];
    const ciplList = this.form.docInternationalForm.listCommodityCIPL;

    ciplList?.forEach((cipl) => {
      validations.push(!parseZodError(itemDetailSchema, cipl.name));
      validations.push(!parseZodError(quantitySchema, cipl.quantity));
      validations.push(!parseZodError(goodsPriceSchema, cipl.goodsPrice));
    });

    return !Object.values(validations).includes(false);
  }

  get payload(): AddShipmentBookingV2 {
    const { shipmentPacketId, shipmentGoodDetail } = this.shipmentDetail;
    const f = this.form;

    const sttInsuranceType =
      !this.insuranceBasic &&
      !this.isExistingInsuranceApplied
        ? "free"
        : this.form.insurance;

    return new AddShipmentBookingV2({
      shipmentPackageId: this.validationPrefix(["TKP"]) ? 0 : shipmentPacketId,
      goodsNames: shipmentGoodDetail.map((item) => item["shipment_goods_name"]),
      sttWeightAttachFiles: f.adjustmentWeightAttachments.filter((key) => key),
      stt: new ShipmentSttDetail({
        ...this.shipmentSttDetailPayload,
        sttNo: f.sttNo,
        sttNoRefExternal: f.referenceExternal,
        sttProductType: f.productName,
        sttOriginCityId: this.originDistrictDetail.cityCode,
        sttOriginDistrictId: this.originDistrictDetail.code,
        sttDestinationCityId: this.destinationCity.cityCode,
        sttDestinationDistrictId: this.destinationCity.code,
        sttSenderName: f.sender,
        sttSenderPhone: (f.phoneCodeSender + f.phoneSender).replace(/\+/g, ""),
        sttSenderAddress: f.addressSender,
        sttIsSaveSender: f.isSaveSender,
        sttRecipientName: f.receiver,
        sttRecipientPhone: (f.phoneCodeReceiver + f.phoneReceiver).replace(
          /\+/g,
          ""
        ),
        sttRecipientAddress: f.addressReceiver,
        sttIsSaveReceiver: f.isSaveReceiver,
        sttAttachFiles: [
          f.docInternationalForm.imageBeforePackingUrl,
          f.docInternationalForm.imageAfterPackingUrl
        ].filter((img) => img),
        sttClientSttId: f.clientName.clientId,
        sttInsuranceType
      }),
      saveCustomerSender: f.isSaveSender,
      saveCustomerRecipient: f.isSaveReceiver,
      otherShipperTicketCode: this.shipmentDetail.dataRaw
        ?.other_shipper_ticket_code,
      sttClient: f.clientName.clientId,
    });
  }

  get shipmentSttDetailPayload(): ShipmentSttDetail {
    const s = this.shipmentDetail;
    const f = this.form;

    const shipmentC1Cod =
      f.shipmentId.startsWith(
        FlagsFeatureShipmentC1.feature_shipment_c1.getValue()
      ) && s.shipmentIsCod;

    return new ShipmentSttDetail({
      sttCommodityCode:
        this.commodity.commodityCode ||
        (!this.validationPrefix(["T1", "B1", "B2", "TKLP"]) ? "GEN" : ""),
      sttInsuranceType: f.insurance,
      sttGoodsStatus: s.shipmentGoodsStatus,
      sttGoodsEstimatePrice: this.parseNumber(f.estimationPrice),
      sttTaxNumber: s.shipmentNpwpNumber,
      sttIsWoodpacking: f.woodpacking,
      sttIsCod: f.isCOD,
      sttIsDfod: f.isDFOD,
      sttCodAmount:
        f.isDFOD || f.serviceType === "non-cod"
          ? 0
          : this.parseNumber(f.codAmount),
      sttCodFee: this.parseNumber(String(s.codFee)),
      sttPieces: f.pieces.map((piece: SttPiecesV2) => {
        const { width, length, height } = piece.dimension as DimensionPieces;

        return new PiecesApiRequest({
          sttPieceGrossWeight: this.parseNumber(piece.grossWeight),
          sttPieceWidth: width,
          sttPieceLength: length,
          sttPieceHeight: height,
          sttPieceVolumeWeight: this.parseNumber(String(piece.volumeWeight))
        });
      }),
      sttIsDo: s.isDO,
      isMixpack: false,
      sttShipmentId: s.shipmentAlgoId,
      sttPiecePerPack: Number(s.piecePerPack || 0),
      sttNextCommodity: s.nextCommodity,
      postalCodeDestination: String(this.postalCodeDestination.name),
      codHandling: shipmentC1Cod ? s.shipmentCodHandling : "",
      discountFavoritePercentage: this.validationPrefix(SHIPMENT_ID_FAVOURITE)
        ? s.discountFavoritePercentage
        : 0,
      sttRecipientAddressType: f.addressReceiverType.value,
      sttCiplAttachFiles: [
        f.docInternationalForm.imageBeforePackingUrl,
        f.docInternationalForm.imageAfterPackingUrl
      ].filter((img) => img),
      sttKtpImage: f.docInternationalForm.imageIdUrl,
      sttTaxImage: f.docInternationalForm.imageTaxUrl,
      sttRecipientEmail: f.docInternationalForm.email,
      sttIdentityNumber: f.docInternationalForm.idNumber,
      sttInterTaxNumber: f.docInternationalForm.taxNumber,
      sttCipl: this.docInternationalCommodityCipl
    });
  }
  get docInternationalCommodityCipl() {
    const list = this.form.docInternationalForm.listCommodityCIPL || [];

    const hasAnyValue = list.some((cipl: CommodityCIPL) => {
      const hasQuantity = !!cipl?.quantity;
      const hasPrice = !!cipl?.goodsPrice;
      const hasName = !!(
        cipl?.commodity?.nameEn ||
        cipl?.commodity?.nameId ||
        cipl?.name
      );

      return hasQuantity || hasPrice || hasName;
    });

    if (!hasAnyValue) return [];

    return list.map(
      (cipl: CommodityCIPL) =>
        new SttCiplRequest({
          quantity: this.parseNumber(cipl.quantity),
          itemPrice: this.parseNumber(cipl.goodsPrice),
          itemDetailEn: cipl.commodity.nameEn || cipl.name,
          itemDetail: cipl.commodity.nameId || cipl.name,
          commodityHsCode: cipl.commodity.hsCode
        })
    );
  }

  get isLastShipment(): boolean {
    return Boolean(
      this.data.length && this.selectedIndex === this.data.length - 1
    );
  }
  onSkipBooking() {
    if (this.isLastShipment) {
      this.onCloseForm();
      return;
    }

    this.onResetForm();
    this.$emit("skip");
    this.$emit("update:selectedIndex", this.selectedIndex + 1);

    this.$nextTick(() => {
      this.initShipmentForm();
    });
  }

  async processShipmentId(type = "") {
    let newPayload: AddShipmentBookingV2 = new AddShipmentBookingV2();
    if (this.payload.stt.sttNoRefExternal.startsWith("TKP")) {
      const clientIdCourrierRecommendationConfig = FlagsMedusa.client_id_courrier_recommendation_config.getValue();
      newPayload = new AddShipmentBookingV2({
        ...this.payload,
        sttClient: Number(clientIdCourrierRecommendationConfig)
      });
    } else {
      newPayload = new AddShipmentBookingV2({
        ...this.payload,
        isCrossCountryCod: this.isCrossCountryCod,
        prefixCurrency: this.prefixCurrency
      });
    }

    const goodsDetail = newPayload.stt.sttPieces.map((item) => {
      return {
        shipment_goods_weight: item.sttPieceGrossWeight,
        shipment_goods_length: item.sttPieceLength,
        shipment_goods_width: item.sttPieceWidth,
        shipment_goods_height: item.sttPieceHeight
      };
    });

    const shipmentTable = new ShipmentIdTable({
      ...this.shipmentDetail,
      shipmentAlgoId: newPayload.stt.sttShipmentId,
      shipmentProduct: newPayload.stt.sttProductType,
      shipmentRecipientName: newPayload.stt.sttRecipientName,
      shipmentDestinationDistrict: this.destinationCity,
      shipmentGoodDetail: goodsDetail
    });

    const shipmentData = this.isAddAddress
      ? this.mapPayloadToShipmentIdTable(newPayload, goodsDetail)
      : shipmentTable;
    this.$emit(
      "bookingShipment",
      newPayload,
      shipmentData,
      type,
      this.isAddAddress
    );
  }

  onSuccessProcees() {
    this.onResetForm();
    this.initShipmentForm();

    this.$nextTick(() => {
      this.scrollToTop();
    });
  }

  onErrorProcess(err: any) {
    const response = err.response;
    const errorResponse = parsingErrorResponse(err, "", this.processShipmentId);
    const resetGuardSubmit = () =>
      BookingController.setGuardBookingSubmit(false);

    if ([INTERNET_ERROR, INTERNAL_SERVER_ERROR].includes(errorResponse.type)) {
      resetGuardSubmit();
      MainAppController.showErrorMessage(errorResponse);
      return;
    }

    const locale =
      AccountController.accountData.countryCode === "id" ? "id" : "en";

    const messageEn = response?.data?.message?.en || "";
    const errMessage =
      response?.data?.message?.[locale] || response?.data?.message?.id;
    const checkError = ERROR_SPESIFICATION(messageEn);
    const isTKPAlreadyBooked = messageEn.includes(
      "external reference number is already in use"
    );

    this.handleSpecificErrorCases(
      checkError,
      errMessage,
      isTKPAlreadyBooked,
      resetGuardSubmit
    );
  }
  handleSpecificErrorCases(
    checkError: any,
    errMessage: string,
    isTKPAlreadyBooked: boolean,
    resetGuardSubmit: () => void
  ) {
    if (ShipmentBookingController.showModalDetailBookingShipment) {
      resetGuardSubmit();
      this.dispatchErrorMessage(checkError, errMessage);
      return;
    }

    if (!isTKPAlreadyBooked) {
      resetGuardSubmit();
      ShipmentBookingController.setShowModalDetailBookingShipment(true);
      return;
    }

    this.dispatchErrorMessage(checkError, errMessage);
    ShipmentBookingController.setErrorDestination(
      checkError?.errorDestination || false
    );
    ShipmentBookingController.setErrorEmbargo(
      checkError?.isErrorEmbargo || false
    );
    resetGuardSubmit();

    return false;
  }
  dispatchErrorMessage(checkError: any, errMessage: string) {
    MainAppController.showErrorMessage(
      new ErrorMessageEntities({
        title: checkError.statusError
          ? checkError.headerError
          : this.$t("bookingV3.bookButton.failedBook"),
        message: checkError.statusError ? checkError.errorMsg : errMessage,
        type: checkError.statusError ? SPECIAL_ERROR : CLIENT_ERROR,
        onClose: () => {
          dataLayer("shipment_booking_button_clicked", {}, [
            "timestamp",
            "userType",
            "userId"
          ]);
          MainAppController.closeErrorMessage();
        }
      })
    );
  }

  mapPayloadToShipmentIdTable(
    payload: AddShipmentBookingV2,
    goodsDetail: any[]
  ) {
    return new ShipmentIdTable({
      shipmentId: payload.stt.sttShipmentId,
      shipmentAlgoId: payload.stt.sttShipmentId,
      shipmentProduct: payload.stt.sttProductType,
      shipmentDestinationCity: this.destinationCity,
      shipmentDestinationDistrict: this.destinationCity,
      shipmentSenderName: this.form.sender,
      shipmentSenderAddress: this.form.addressSender,
      shipmentSenderPhone: this.form.phoneSender,
      shipmentSenderPhoneCode: this.form.phoneCodeSender,
      shipmentSenderPhoneFlag: this.form.phoneFlagSender,
      shipmentRecipientName: this.form.receiver,
      shipmentRecipientAddress: this.form.addressReceiver,
      shipmentRecipientPhone: this.form.phoneReceiver,
      shipmentRecipientPhoneCode: this.form.phoneCodeReceiver,
      shipmentRecipientPhoneFlag: this.form.phoneFlagReceiver,
      shipmentCommodityId: this.form.commodity.id,
      shipmentCommodityCode: payload.stt.sttCommodityCode,
      shipmentCommodityName: this.form.commodity.name,
      shipmentGoodsStatus: payload.stt.sttGoodsStatus,
      shipmentInsurance: payload.stt.sttInsuranceType,
      shipmentGoodsPriceEstimation: payload.stt.sttGoodsEstimatePrice,
      shipmentNpwpNumber: payload.stt.sttTaxNumber,
      shipmentGoodDetail: goodsDetail,
      shipmentIsCod: payload.stt.sttIsCod,
      shipmentIsDfod: payload.stt.sttIsDfod,
      shipmentCodHandling: payload.stt.codHandling,
      shipmentIsWoodpacking: payload.stt.sttIsWoodpacking,
      shipmentPacketId: payload.shipmentPackageId,
      shipmentChargeableWeight: this.bookingSummary.totalChargeableWeight,
      isDO: payload.stt.sttIsDo,
      piecePerPack: payload.stt.sttPiecePerPack,
      nextCommodity: payload.stt.sttNextCommodity,
      codAmount: payload.stt.sttCodAmount,
      codFee: payload.stt.sttCodFee,
      postalCodeDestination: payload.stt.postalCodeDestination
    });
  }

  scrollToTop() {
    const el = document.getElementById("modal-shipment-v3-parent");
    if (!el) {
      return;
    }
    el.scroll({
      top: 0,
      behavior: "smooth"
    });
  }

  estimationShipmentPrefix(shipmentId: string) {
    const prefixList = ["AP", "AS", "ARA", "ARB", "AD", "AG"];
    const findPrefix = prefixList.find((item: string) =>
      shipmentId.toUpperCase()?.startsWith(item)
    );
    return findPrefix ?? "";
  }

  get maxPieces() {
    return this.form.isVendorNinjaDestination ? 1 : this.masterData.maxPieces;
  }

  internationalDocumentDetailData = new RequestInternationalDocumentDetail({
    afterPacking: false,
    commodity: false,
    email: false,
    idcIsIdentityNumber: false,
    idcIsTaxIdentificationNumber: false,
    ktp: false,
    npwp: false
  });
  async getInternationalDocConfig() {
    const resp = await InternationalDocumentController.getInternationalDocumentDetail(
      {
        dest: this.destinationCity.cityId,
        origin: this.originDistrictDetail.cityId
      }
    );

    this.internationalDocumentDetailData = resp;
    this.currentIndex = 100;
  }

  validateEstimationPrice(price: string): boolean {
    const validateAll = price ? this.isEstimationPriceValid : false;
    if (!validateAll) {
      this.currentIndex = 100;
    }
    return validateAll;
  }

  get excludeEstimationValidation() {
    if (this.form.isDFOD) {
      return !this.masterData.dfodActiveConfig?.ccoId;
    }

    if (this.form.isCOD) {
      return !this.masterData.codActiveConfig?.ccoId;
    }

    return false;
  }

  parseNumber(value: string): number {
    return parseByCountry(value, { country: this.accountCountryCode });
  }

  formatWeight(value: number) {
    return formatByCountry(value, {
      type: "weight",
      country: this.accountCountryCode
    });
  }

  formatPrice(value: number) {
    return formatByCountry(value, {
      type: "money",
      country: this.accountCountryCode,
      prefix: this.accountCountryCode?.toUpperCase() === "MY" ? "RM" : "Rp"
    });
  }

  // client cod international
  get originCountryCode() {
    const code =
      this.districtDetail.countryCode ||
      AccountController.accountData.countryCode;
    return (code || "ID").trim().toUpperCase();
  }

  get isCorporatePrefix(): boolean {
    return this.validationPrefix(["C1", "C2"]);
  }

  get isCrossCountryRoute(): boolean {
    return Boolean(
      this.isCorporatePrefix &&
        !!this.destinationCity?.id &&
        this.destinationCity.countryCode !== this.originCountryCode
    );
  }

  get isCrossCountryCod(): boolean {
    return this.isCrossCountryRoute && (this.form.isCOD || this.form.isDFOD);
  }

  // AP/AS shipment only: retail COD/DFOD gating by route country.
  // - origin non-ID (any non-ID origin) cannot use COD/DFOD
  // - origin ID to a non-ID destination cannot use COD/DFOD
  // Only applies once a destination is selected; empty destination keeps COD enabled.
  // Scoped to AP/AS (isShipmentFavorite) per requirement — other shipment
  // types keep their existing serviceType handling untouched.
  get isApAsRouteCodDisabled(): boolean {
    if (!this.shipmentDetail?.shipmentAlgoId) return false;
    if (!this.isShipmentFavorite) return false;
    if (!this.destinationCity?.id) return false;
    const originCode = this.originCountryCode;
    const destCode = (this.destinationCity.countryCode || "")
      .trim()
      .toUpperCase();
    if (!originCode || !destCode) return false;
    if (originCode !== "ID") return true;
    return destCode !== "ID";
  }

  get prefixCurrency() {
    if (this.isCrossCountryCod) {
      return (
        this.form.destinationCountry.currencySymbol
      );
    }

    return "Rp";
  }
}

export default ModalShipmentV3;
